import zod from "zod";
import { ResourceListSearchParams } from "src/system/useResourceList/useResourceList.types.ts";

export const urlStateValidationSchema = zod.object({
  [ResourceListSearchParams.FilterModelLogicOperator]: zod.string().optional(),
  [ResourceListSearchParams.FilterModel]: zod
    .record(
      zod.string(),
      zod.object({
        v: zod.any(),
        o: zod.string(),
      }),
    )
    .optional(),
  [ResourceListSearchParams.NotAppliedFilterModel]: zod
    .record(
      zod.string(),
      zod.object({
        v: zod.any(),
        o: zod.string(),
      }),
    )
    .optional(),
  [ResourceListSearchParams.SortModel]: zod
    .record(zod.string(), zod.string().nullable())
    .optional(),
  [ResourceListSearchParams.PageSize]: zod.number().optional(),
  [ResourceListSearchParams.Page]: zod.number().optional(),
});

export const DEVELOPER_COLUMNS = ["id"];
